<script setup lang="ts">
/**
 * 1.1.79: 筛选漏斗图标（**实心**）。
 *
 * 原来这个漏斗是 `fill="none"` 的描边空心版，在深色侧边栏里显得又细又轻（用户反馈"图标丑"）；
 * 「筛选范围设置」页的标题/空态更早还用字符 `⛃`（一个不成形的符号）。
 * 统一改成实心漏斗：fill + 同色细描边（只为把拐角磨圆，不改变实心观感）。
 *
 * 尺寸/颜色都从外面传（class 会落到根 svg 上），例如：
 *   <FilterFunnelIcon class="h-[18px] w-[18px] text-sky-400" />
 */
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1.2"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M3 5h18l-7 8v6l-4-2v-4z" />
  </svg>
</template>
